module.exports = __webpack_public_path__ + "img/monitor2.0a0ac79e.png";